import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Box,
} from '@mui/material'
import { useState, useCallback, memo, useEffect, useMemo } from 'react'
import CalculateIcon from '@mui/icons-material/Calculate'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import HomeIcon from '@mui/icons-material/Home'
import { useRouter } from '../hooks/useRouter'
import { useAuth } from '../contexts/AuthContext'
import { isVipActive } from '../libs/helper'
import VipDialog from './VipDialog'

const CustomBottomNavigation = memo(() => {
  const router = useRouter()
  const currentPath = router.pathname
  const { authData } = useAuth()

  const [isOpenVipDialog, setIsOpenVipDialog] = useState(false)

  // Memoize the active index based on current path
  const activeIndex = useMemo(() => {
    switch (currentPath) {
      case '/custom':
        return 0
      case '/contact-admin':
        return 1
      case '/':
        return 2
      default:
        return 2 // Default to home
    }
  }, [currentPath])

  // Memoized navigation handler
  const handleNavigationChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      if (newValue === 0) {
        if (!isVipActive(authData)) {
          setIsOpenVipDialog(true)
          return
        }
        router.push('/custom')
      } else if (newValue === 1) {
        router.push('/contact-admin')
      } else {
        router.push('/')
      }
    },
    [authData, router],
  )

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        maxWidth: '425px',
        width: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      <VipDialog
        open={isOpenVipDialog}
        onClose={() => setIsOpenVipDialog(false)}
      />
      <BottomNavigation
        showLabels
        value={activeIndex}
        onChange={handleNavigationChange}
        sx={{
          backgroundColor: 'transparent',
          height: 'auto',
          padding: '8px',
          '& .MuiBottomNavigationAction-root': {
            maxWidth: 'none',
            padding: '6px 12px',
            minWidth: '100px',
            borderRadius: '12px',
            color: '#666666',
            '&.Mui-selected': {
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.875rem',
            transition: 'none',
            '&.Mui-selected': {
              fontSize: '0.875rem',
            },
          },
          '& .MuiBottomNavigationAction-icon': {
            marginBottom: '4px',
          },
        }}
      >
        <BottomNavigationAction
          icon={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CalculateIcon />
              <span>คำนวณหวย</span>
            </Box>
          }
        />
        <BottomNavigationAction
          icon={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AdminPanelSettingsIcon />
              <span>Admin</span>
            </Box>
          }
        />
        <BottomNavigationAction
          icon={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <HomeIcon />
              <span>หน้าแรก</span>
            </Box>
          }
        />
      </BottomNavigation>
    </Paper>
  )
})

CustomBottomNavigation.displayName = 'CustomBottomNavigation'

export default CustomBottomNavigation
